import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom"; // Import for Portal
import styled from "styled-components";
import axios from "axios";
import coinIcon from "../assets/coin.png";
import Streaks from "./Streaks";
import Lottie from "lottie-react";
import level1Json from "../assets/4P6ILeUWsw.json";
import level2Json from "../assets/level_2.json";
import level3Json from "../assets/level_3 1.json";
import level4Json from "../assets/level_4.json";
import level5Json from "../assets/level_5.json";
import level6Json from "../assets/level_6.json";
import level7Json from "../assets/level_7.json";
import level8Json from "../assets/level_8.json";
import level9Json from "../assets/level_9.json";
import level10Json from "../assets/level_10.json";
import healthtip from "../assets/HealthTip.json";
import { InfoCircleOutlined } from "@ant-design/icons";
import { withUIDirectives } from "components/utils/UI_Directive/showUIDirectives";

interface PointsInfo {
  user_points_balance: number;
  points_map: {
    Lifetime_points: number;
    Active_points: number;
    Expired_points: number;
  };
}

const levelJsonMap: any = {
  1: level1Json, 2: level2Json, 3: level3Json, 4: level4Json, 5: level5Json,
  6: level6Json, 7: level7Json, 8: level8Json, 9: level9Json, 10: level10Json
};

const PointsBalance: React.FC = () => {
  const API_URL_ORGINFO = `${process.env.REACT_APP_API_URL}/api/points`;
  const [loading, setLoading] = useState(true);
  const [balancePoints, setBalancePoints] = useState<PointsInfo>({
    user_points_balance: 0,
    points_map: { Lifetime_points: 0, Active_points: 0, Expired_points: 0 },
  });

  const [showModal, setShowModal] = useState(false);
  const [levelData, setLevelData] = useState<any>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showLevelInfo, setShowLevelInfo] = useState(false);
  const [showPointsInfo, setShowPointsInfo] = useState(false);

  const sessionUid = localStorage.getItem("session_uid") ?? "";
  const userUid = localStorage.getItem("user_uid") ?? "";
  const levelPopupRef = useRef<HTMLDivElement>(null);

  const fetchPoints = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL_ORGINFO, {
        headers: {
          Accept: "application/json",
          "user-uid": userUid,
        },
        withCredentials: true,
      });

      if (response.status === 200) {
        const data = withUIDirectives(response.data);

        setBalancePoints({
          user_points_balance: data.data.user_points_balance,
          points_map: data.data.points_map,
        });
      }
    } catch (error) {
      console.error("Error fetching points:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLevelData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/my-level`, {
        headers: {
          Accept: "application/json",
          "user-uid": userUid,
        },
        withCredentials: true,
      });

      if (response.status === 200) {
        const data = withUIDirectives(response.data);
        setLevelData(data.data);
      }
    } catch (err) {
      console.error("Failed to fetch level:", err);
    }
  };

  useEffect(() => {
    fetchLevelData();
    fetchPoints();
  }, []);

  // --- 2. PORTAL HELPER (Fixes the Glitch) ---
  const ModalPortal = ({ children }: { children: React.ReactNode }) => {
    return ReactDOM.createPortal(children, document.body);
  };

  return (
    <PointsBalanceContainer>

      {/* --- LEVEL CARD SECTION --- */}
      <div ref={levelPopupRef} style={{ width: "100%", height: "100%" }}>
        <Card onClick={() => setShowPopup(true)}>
          <Lottie
            animationData={levelJsonMap[levelData?.current_level] || healthtip}
            style={{ width: 40, height: 40, marginBottom: 0 }}
            loop autoplay
          />
          <Content>
            <Points>{levelData?.current_level ?? "--"}</Points>
            <Label>My level</Label>
          </Content>
          {/* REMOVED Info Icon from here */}
        </Card>

        {showPopup && levelData && (
          <ModalPortal>
            <ModalOverlay onClick={() => setShowPopup(false)}>
              <SmallModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={() => setShowPopup(false)}>&times;</CloseButton>

                {/* Header with Info Icon */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 10 }}>
                  <LevelLabel>Level {levelData.current_level}</LevelLabel>
                  <InfoCircleOutlined
                    onClick={() => setShowLevelInfo(true)}
                    style={{ fontSize: 18, color: "#007bff", cursor: "pointer" }}
                    title="View Level Breakdown"
                  />
                </div>

                <Lottie
                  animationData={levelJsonMap[levelData?.current_level] || healthtip}
                  style={{ width: 80, height: 80, margin: "0 auto" }}
                />

                <LevelName>{levelData.level_character}</LevelName>
                <Description>{levelData.level_character_description}</Description>

                {/* --- NEW EXPLANATION ADDED HERE --- */}
                <Description style={{ marginTop: "12px", color: "#444", fontWeight: 500 }}>
                  Your current points is <strong>{levelData.current_xp}</strong> and you need{" "}
                  <strong>{levelData.xp_needed_for_next_level}</strong> points to reach next level.
                </Description>

              </SmallModalContent>
            </ModalOverlay>
          </ModalPortal>
        )}

        {/* Level Info Image Modal */}
        {showLevelInfo && (
          <ModalPortal>
            <ModalOverlay onClick={() => setShowLevelInfo(false)} style={{ zIndex: 10000 }}>
              <ModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={() => setShowLevelInfo(false)}>&times;</CloseButton>
                <Header><Title>Level Breakdown</Title></Header>
                <img
                  src={require("../assets/level_I_Icon.png")}
                  alt="Level Info"
                  style={{ width: "100%", borderRadius: 10, marginTop: 8 }}
                />
              </ModalContent>
            </ModalOverlay>
          </ModalPortal>
        )}
      </div>

      {/* --- STREAKS CARD SECTION --- */}
      <div style={{ width: "100%" }}>
        <Streaks />
      </div>

      {/* --- POINTS CARD SECTION --- */}
      <div style={{ width: "100%", height: "100%" }}>
        <Card onClick={() => setShowModal(true)}>
          <Icon src={coinIcon} alt="Coin Icon" />
          <Content>
            <Points>{balancePoints.user_points_balance}</Points>
            <Label>Points</Label>
          </Content>
          {/* REMOVED Info Icon from here */}
        </Card>

        {/* Points Breakdown Modal */}
        {showModal && (
          <ModalPortal>
            <ModalOverlay onClick={() => setShowModal(false)}>
              <ModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={() => setShowModal(false)}>&times;</CloseButton>

                <Header style={{ flexDirection: 'row' }}>
                  <Icon src={coinIcon} alt="Coin" style={{ width: 32, height: 32, margin: 0 }} />
                  <Title>Points Breakdown</Title>

                  {/* Info Icon Moved Inside Header */}
                  <InfoCircleOutlined
                    onClick={() => setShowPointsInfo(true)}
                    style={{ fontSize: 20, color: "#007bff", cursor: "pointer", marginLeft: 8 }}
                    title="View Points Info"
                  />
                </Header>

                <PointsGrid>
                  {/* Main Balance Card */}
                  <MainPointCard>
                    <span className="label">Available Balance</span>
                    <span className="value">{balancePoints.user_points_balance}</span>
                  </MainPointCard>

                  {/* Stats Grid */}
                  <StatsRow>
                    <StatCard color="#E8F5E9">
                      <span className="label">Active</span>
                      <span className="value">{balancePoints.points_map.Active_points}</span>
                    </StatCard>
                    <StatCard color="#E3F2FD">
                      <span className="label">Lifetime</span>
                      <span className="value">{balancePoints.points_map.Lifetime_points}</span>
                    </StatCard>
                    <StatCard color="#FFEBEE">
                      <span className="label">Expired</span>
                      <span className="value">{balancePoints.points_map.Expired_points}</span>
                    </StatCard>
                  </StatsRow>
                </PointsGrid>

              </ModalContent>
            </ModalOverlay>
          </ModalPortal>
        )}

        {/* Points Info Image Modal */}
        {showPointsInfo && (
          <ModalPortal>
            <ModalOverlay onClick={() => setShowPointsInfo(false)} style={{ zIndex: 10000 }}>
              <ModalContent onClick={(e) => e.stopPropagation()}>
                <CloseButton onClick={() => setShowPointsInfo(false)}>&times;</CloseButton>
                <Title>Points Info</Title>
                <img
                  src={require("../assets/Points_i_icon.png")}
                  alt="Points Info"
                  style={{ width: "100%", borderRadius: 10, marginTop: 8 }}
                />
              </ModalContent>
            </ModalOverlay>
          </ModalPortal>
        )}
      </div>
    </PointsBalanceContainer>
  );
};

export default PointsBalance;

// --- STYLED COMPONENTS ---

const PointsBalanceContainer = styled.div`
  display: grid;
  /* 3 Equal columns always. */
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  align-items: stretch;

  @media (min-width: 1024px) {
    gap: 16px;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--card-background, #fff);
  padding: 8px 4px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
  height: 100%;
  min-height: 85px;
  box-sizing: border-box;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 12px;
    padding: 12px 16px;
    min-height: 90px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  
  @media (min-width: 768px) {
    align-items: flex-start;
    text-align: left;
  }
`;

const Label = styled.span`
  font-size: 11px;
  color: #888;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 4px;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 12px;
    margin-top: 0;
  }
`;

const Points = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: var(--text-color, #333);
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

const Icon = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin-bottom: 2px;
  
  @media (min-width: 768px) {
    width: 36px;
    height: 36px;
    margin-bottom: 0;
  }
`;

// Modal Styles
const ModalOverlay = styled.div`
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex; align-items: center; justify-content: center;
  z-index: 999;
`;

const ModalContent = styled.div`
  background: #fff; padding: 24px; border-radius: 12px;
  width: 90%; max-width: 500px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2);
  position: relative; text-align: center;
`;

const SmallModalContent = styled(ModalContent)`
  max-width: 360px;
`;

const CloseButton = styled.button`
  position: absolute; top: 12px; right: 12px;
  background: transparent; border: none;
  font-size: 24px; cursor: pointer; color: #666;
`;

const Header = styled.div`
  display: flex; align-items: center; justify-content: center; gap: 10px;
  margin-bottom: 10px;
`;

const Title = styled.h3`
  margin: 0; font-size: 20px; font-weight: 700;
`;

// --- NEW STYLED COMPONENTS FOR POINTS POPUP ---

const PointsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

const MainPointCard = styled.div`
  background: linear-gradient(135deg, #094752, #1D9DA2);
  padding: 24px;
  border-radius: 16px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(9, 71, 82, 0.2);

  .label {
    font-size: 14px;
    opacity: 0.9;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  .value {
    font-size: 42px;
    font-weight: 800;
  }
`;

const StatsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
`;

const StatCard = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  padding: 16px 10px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  .label {
    font-size: 11px;
    color: #555;
    font-weight: 600;
  }
  
  .value {
    font-size: 16px;
    font-weight: 700;
    color: #333;
  }
`;

const LevelLabel = styled.div` font-size: 16px; font-weight: bold; color: #333; `;
const LevelName = styled.div` font-size: 16px; font-weight: bold; margin-top: 8px; color: #222; `;
const Description = styled.div` font-size: 12px; color: #666; margin-top: 4px; `;